import styled from 'styled-components';
import { typeScale } from 'core/utils';
import Button from 'core/ui/Button';

export const Footer = styled.footer`
	padding: ${typeScale(2)};
	padding-bottom: ${typeScale(6)};
	margin-top: auto;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-gap: ${typeScale(1)};

	@media (min-width: 620px) {
		grid-template-columns: repeat(2, 210px);
		padding: ${typeScale(2)};
		justify-content: flex-end;
	}
`;

export const FooterButton = styled(Button)`
	@media (max-width: 767px) {
		font-size: 14px;
	}
`;
